<template>
  <OnboardingWrapper>
  <div class="game-detail-recordings">
    <div>
      <transition name="fade">
        <Loading v-if="isLoading"></Loading>
      </transition>
    </div>
    <template v-if="resultVisible">
      <RecordingResults @toMainMenuChild="toMainMenu"></RecordingResults>
    </template>
    <template v-if="mainVisible">
      <div class="gda-recordings-box" v-if="!resultsExpanded">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-clipboard-data gda-icon"
          viewBox="0 0 16 16"
        >
          <path
            d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z"
          />
          <path
            d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"
          />
          <path
            d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"
          />
        </svg>
        <h3 class="gda-text">Gameplay</h3>
        <button class="recording-btn-add" v-on:click="newSession()">
          Add New Playsession
        </button>
        <hr class="divider" />
        <!--This is a periods list, NOT a recordings list, item is a different playperiod in the obj*-->
        <div class="gda-recordings-list">
          <div v-for="item in recordingObj" class="gda-recordings">
            <div class="gda-text-container">
              <div class="survey-title" v-if="item.name">{{ item.name }}</div>
              <div class="survey-title" v-else>No Name</div>
              <p v-if="item.status == 2">{{ item.responses }}In-progress</p>
              <p v-if="item.status == 1">{{ item.responses }}Completed</p>
              <div class = "new-text" v-if = "item.status == 2">In-progress</div>
              <div class = "new-text" v-if = "item.status == 0">Not Published Yet</div>
              <div class = "new-text" v-if = "item.status == 1">Complete!</div>
            </div>

            <div class="button-container">
              <button
                class="session-btn"
                v-if="item.status != 0"
                v-on:click="addTesters(item)"
              >
                Manage Testers
              </button>
              <button
                class="session-btn"
                v-if="item.status == 1 || 2"
                v-on:click="viewDetails(item)"
              >
                Details
              </button>
              <button
                class="session-btn"
                v-on:click="viewResults(item)"
              >
                Results
              </button>
              <button
                class="session-btn"
                v-if="item.status == 0"
                v-on:click="publishRecording(item.playPeriodID)"
              >
                Publish
              </button>

            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- This is a detail container that is able to hold any other component, we swap out the displayed component depending on
    the button clicked, or currentContentType -->
    <RecordingDetailsContainer
      :key="this.displayedRecording==null ? (this.currentContentType + 'none') : (this.currentContentType + this.displayedRecording.sID)"
      :contentType="currentContentType"
      :recording-obj="displayedRecording"
      :expanded="resultsExpanded"
      v-if="mainVisible"
      @toggle-expand="toggleResultsExpand"
      :class="{ 'results-expanded': resultsExpanded }"
    ></RecordingDetailsContainer>
  </div>
</OnboardingWrapper>
</template>

<script>
import Loading from "../loading/index.vue";
import RecordingResults from "./Recordings/RecordingResults.vue";
import RecordingDetails from "./Recordings/RecordingDetails.vue";
import RecordingDetailsContainer from "./Recordings/RecordingDetailsContainer.vue";
import AddTester from "./Recordings/AddTester.vue";
import GamesObject, { deletePlayPeriod } from "../../Firestore/GamesObject.js";
import OnboardingWrapper from '../onboarding/OnboardingWrapper.vue';
import { onboardingService } from '@/services/OnboardingService';
import { initializePageOnboarding } from '@/services/onboardingConfigs';

export default {
  name: "gameDetailRecordings",
  components: {
    RecordingResults,
    Loading,
    RecordingDetailsContainer,
    AddTester,
    RecordingDetails,
    OnboardingWrapper
  },
  props: {
    detail: {
      type: Object
    }
  },
  data() {
    // Return Game Detail Recording
    return {
      //msg: "gameDetailRecordings", //Dont know if need this but keep for now
      recordingObj: [],
      mainVisible: true,
      isLoading: false,
      resultVisible: true,
      displayedRecording: null,
      currentContentType: 'none',
      resultsExpanded: false, // when true, hides the Gameplay list card so the results view (video/notes) can take the full width
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,  // 0: Tester, 1: Company, 2: Admin
    }
  },
  methods: {
    newSession() {
      this.$router.push({ name: "createSession" });
    },
    showLoading() {
      this.isLoading = true;
      setTimeout(() => (this.isLoading = false), 200);
    },
    syncSidebarVisibility() {
      this.$emit('toggle-sidebar', this.resultsExpanded);
    },
    //Goes back to main menu
    toMainMenu() {
      this.showLoading();
      this.mainVisible = true;
      this.resultVisible = false;
      this.resultsExpanded = false;
      this.syncSidebarVisibility();
    },
    addTesters(recording) {
      this.currentContentType = "testers";
      this.showLoading();
      this.displayedRecording = recording;
      this.resultsExpanded = false;
      this.syncSidebarVisibility();
      //console.log(this.displayedRecording);
    },
    viewDetails(recording) {
      this.currentContentType = "details";
      this.showLoading();
      this.displayedRecording = recording;
      this.resultsExpanded = false;
      this.syncSidebarVisibility();
      //console.log(this.displayedRecording);
    },
    viewRecording(recording) {
      this.currentContentType = "viewer";
      this.showLoading();
      this.displayedRecording = recording;
      this.resultsExpanded = false;
      this.syncSidebarVisibility();
      //console.log(this.displayedRecording);
    },
    //viewResults should be the Recording Viewer UI, can change name if needed?
    viewResults(recording) {
      this.currentContentType = "results";
      this.showLoading();
      this.displayedRecording = recording;
      this.resultsExpanded = false; // always start collapsed when opening a fresh results view
      this.syncSidebarVisibility();
      //console.log(JSON.parse(JSON.stringify(this.displayedRecording)));
    },
    // Toggled by an 'toggle-expand' event bubbled up from RecordingDetailsContainer
    // (fired by the expand/minimize button on the results view itself).
    toggleResultsExpand() {
      this.resultsExpanded = !this.resultsExpanded;
      this.syncSidebarVisibility();
    },
    publishRecording(playPeriodID) {
      GamesObject.editStatusOfPlayPeriod(playPeriodID, 2)
      .then(() => {
        const item = this.recordingObj.find(p => p.playPeriodID === playPeriodID);
        if (item) {
          this.$set(item, 'status', 2);
        }
      });
    },
    /* KEEP THIS COMMENTED FOR NOW, use as example for implementation within Details page
    */
    deleteSession(playPeriodID) {
      console.log("PlayPeriodID to be deleted: ", playPeriodID)
      GamesObject.deletePlayPeriod(playPeriodID)
      .then(() => {
        this.$bvModal.hide("delete-confirm");
        this.recordingObj = this.recordingObj.filter(p => p.playPeriodID != playPeriodID);
      })

    }
  },

  mounted() {
    GamesObject.getPlayTestPeriods(window.localStorage.getItem("gameId"))
    .then(res => {
      this.recordingObj = res.data;
    })
    // Get user type, if already logged in, set user type
    if (window.localStorage.getItem("userType")) {
      this.userType = parseInt(window.localStorage.getItem("userType"));
        if (this.userType === 1) {
          this.$nextTick(() => {
          initializePageOnboarding(
          'survey',
          this.userType,       
          onboardingService,
          this.$store
        );
  });
}
      // Else ask user to login
    } else {
      this.$router.push({
        name: 'login',
      })
    }
  }
};
</script>

<style scoped>
.game-detail-recordings {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  width: 100%;
  min-width: 0;
}

.gda-recordings-box {
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  width: 30%;
  height: 75vh;
  margin: 0 2%;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.gda-recordings:hover {
  transform: translateY(-2px);                         /* subtle lift */
  box-shadow: 2px 6px 16px rgba(0, 0, 0, 0.12);
}

@media only screen and (max-width: 1330px) {
  .gda-session-box {
    width: 360px;
  }
}

.gda-icon {
  height: 15%;
  color: #aaa;
  margin: 5%;
}

.gda-text {
  color: #fc7727;
}

.session-btn,
.recording-btn-add {
  background-color: #fc7727 !important;
  color: #fff;
  border: none;
  border-radius: 20px !important;  /* more pill-shaped */
  padding: 0.25rem 0.75rem;        /* slightly more horizontal padding */
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
  font-size: 0.85rem;
  transition: background-color 0.2s ease, transform 0.1s ease;  /* smooth hover */
}

.recording-btn-add {
  width: 75%;
  margin-bottom: 3%;
  padding: 1%;
}
.divider {
  border: 1px solid #c2c2c2;
  width: 95%;
  margin: 0 auto;
}
.session-btn {
  height: fit-content;
  white-space: nowrap;
}

.session-btn:hover,
.recording-btn-add:hover {
  background-color: #ff8e4d !important;
  transform: translateY(-1px);   /* micro lift on button hover */
}

.gda-recordings-list {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  width: 100%;
  align-items: center;
  overflow: auto;
}
.gda-recordings-list::-webkit-scrollbar {
  display: none;
}

.gda-recordings {
  width: 90%;
  display: flex;
  flex-direction: column;
  background-color: #fff !important;   /* solid white instead of transparent */
  border: 1px solid #eee !important;   /* lighter border */
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 15px !important;
  align-items: flex-start;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.07);  /* subtler, more modern shadow */
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.button-container {
  display: flex;
  flex-direction: row;
  justify-content: center;  /* left-align instead of space-between */
  gap: 8px;                     /* spacing between buttons */
  width: 100%;
  align-items: flex-end;
  margin-top: 8px;              /* a bit of breathing room above buttons */
}

.gda-text-container {
  display: flex;
  flex-direction: column;
  width: 60%;
}
.survey-title {
  color: #000 !important;
  font-size: large;
  font-weight: bold;
}

.new-text {
  color: #bebebe;
}

#gamedetail-modify {
  position: relative;
  width: 10%;
  height: 40px;
  right: 5%;
  left: 85%;
  top: 50px;
}

:deep(.recordings-detail-container) {
  flex: 1 1 auto;
  width: 100%;
  max-width: none;
  min-width: 0;
}

:deep(.results-expanded) {
  width: 100%;
  flex: 1 1 auto;
}

</style>


// WEBPACK FOOTER //
// src/components/game-detail/GameDetail-Recordings.vue